// talleres_tut.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderServices from '../Header/HeaderServices';
import FooterServices from '../Footer/FooterServices';
import './talleres_tut.css';

const TalleresTut = () => {
  const navigate = useNavigate();
  const [selectedTaller, setSelectedTaller] = useState(null);

  const talleres = [
    {
      id: 1,
      nombre: "Taller de Placas Perforadas",
      imagen: "/images/PCB/PCB1.png",
      descripcion: "Aprende a diseñar y soldar en placas perforadas profesionales.",
      fecha: "15 Nov 2025",
      horario: "9:00 AM - 1:00 PM",
      duracion: "4 horas",
      modalidad: "Presencial",
      cuposDisponibles: "12/20",
      precio: "$45.00",
      certificado: false,
      nivel: "Principiante"
    },
    {
      id: 2,
      nombre: "Arduino para Principiantes",
      imagen: "/images/PCB/PCB1.png",
      descripcion: "Domina Arduino desde cero con proyectos prácticos y ejercicios guiados paso a paso.",
      fecha: "22 Nov 2025",
      horario: "2:00 PM - 6:00 PM",
      duracion: "4 horas",
      modalidad: "Virtual",
      cuposDisponibles: "8/15",
      precio: "$35.00",
      certificado: false,
      nivel: "Principiante"
    },
    {
      id: 3,
      nombre: "IoT y Sensores Avanzados",
      imagen: "/images/PCB/PCB1.png",
      descripcion: " Crea proyectos IoT conectados y aprende sobre sensores avanzados.",
      fecha: "28 Nov 2025",
      horario: "10:00 AM - 3:00 PM",
      duracion: "5 horas",
      modalidad: "Híbrido",
      cuposDisponibles: "15/25",
      precio: "$55.00",
      certificado: false,
      nivel: "Avanzado"
    }
  ];

  const handleTallerClick = (taller) => {
    setSelectedTaller(taller);
  };

  const closeModal = () => {
    setSelectedTaller(null);
  };

  const handleBackClick = () => {
    navigate('/tutorial');
  };

  return (
    <div className="talleres-tut-wrapper">
      <HeaderServices />

      {/* Hero Section */}
      <section className="talleres-tut-hero">
        <div className="talleres-tut-hero-container">
          {/* Botón de Regreso */}
          <button onClick={handleBackClick} className="talleres-tut-back-btn">
            <span className="talleres-tut-back-arrow">←</span>
            Volver
          </button>

          <h1 className="talleres-tut-hero-title">
            <span className="talleres-tut-hero-title-main">Talleres </span>
            <span className="talleres-tut-hero-title-accent">Volteon</span>
          </h1>
          <p className="talleres-tut-hero-description">
            Únete a nuestros talleres prácticos donde aprenderás directamente de expertos. 
            Disponibles en formato presencial, virtual e híbrido. Certificación incluida al completar el curso.
          </p>
          <div className="talleres-tut-hero-stats">
            <div className="talleres-tut-stat">
              <span className="talleres-tut-stat-number">3+</span>
              <span className="talleres-tut-stat-label">Talleres</span>
            </div>
            <div className="talleres-tut-stat">
              <span className="talleres-tut-stat-number">0 </span>
              <span className="talleres-tut-stat-label">Graduados XDD</span>
            </div>
          </div>
        </div>
      </section>

      {/* Talleres Grid */}
      <section className="talleres-tut-grid-section">
        <div className="talleres-tut-container">
          <h2 className="talleres-tut-section-title">
            <span className="talleres-tut-title-accent">Próximos</span> Talleres
          </h2>
          
          <div className="talleres-tut-grid">
            {talleres.map((taller) => (
              <div 
                key={taller.id} 
                className="talleres-tut-card"
                onClick={() => handleTallerClick(taller)}
              >
                <div className="talleres-tut-card-image-container">
                  <img 
                    src={taller.imagen} 
                    alt={taller.nombre}
                    className="talleres-tut-card-image"
                  />
                  <div className="talleres-tut-card-badges">
                    <span className="talleres-tut-badge-modalidad">{taller.modalidad}</span>
                    {taller.certificado && (
                      <span className="talleres-tut-badge-certificado">🎓 Certificado</span>
                    )}
                  </div>
                  <div className="talleres-tut-card-overlay">
                    <div className="talleres-tut-overlay-info">
                      <div className="talleres-tut-overlay-item">
                        📅 {taller.fecha}
                      </div>
                      <div className="talleres-tut-overlay-item">
                        ⏰ {taller.horario}
                      </div>
                      <div className="talleres-tut-overlay-item">
                        👥 Cupos: {taller.cuposDisponibles}
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="talleres-tut-card-content">
                  <div className="talleres-tut-card-header">
                    <span className="talleres-tut-card-fecha">📅 {taller.fecha}</span>
                    <span className="talleres-tut-card-nivel">{taller.nivel}</span>
                  </div>
                  
                  <h3 className="talleres-tut-card-title">{taller.nombre}</h3>
                  <p className="talleres-tut-card-description">{taller.descripcion}</p>
                  
                  <div className="talleres-tut-card-info">
                    <div className="talleres-tut-info-item">
                      <span className="talleres-tut-info-icon">⏱️</span>
                      <span className="talleres-tut-info-text">{taller.duracion}</span>
                    </div>
                    <div className="talleres-tut-info-item">
                      <span className="talleres-tut-info-icon">👥</span>
                      <span className="talleres-tut-info-text">{taller.cuposDisponibles}</span>
                    </div>
                  </div>
                  
                  <div className="talleres-tut-card-footer">
                    <span className="talleres-tut-card-precio">{taller.precio}</span>
                    <button 
                      className="talleres-tut-card-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        console.log('Inscribirse:', taller.nombre);
                      }}
                    >
                      Inscribirse Ahora
                      <span className="talleres-tut-btn-arrow">→</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedTaller && (
        <div className="talleres-tut-modal" onClick={closeModal}>
          <div className="talleres-tut-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="talleres-tut-modal-close" onClick={closeModal}>×</button>
            
            <div className="talleres-tut-modal-grid">
              <div className="talleres-tut-modal-image-section">
                <img 
                  src={selectedTaller.imagen} 
                  alt={selectedTaller.nombre}
                  className="talleres-tut-modal-image"
                />
                <div className="talleres-tut-modal-image-badges">
                  <span className="talleres-tut-modal-modalidad">{selectedTaller.modalidad}</span>
                  {selectedTaller.certificado && (
                    <span className="talleres-tut-modal-certificado">🎓 Certificado Incluido</span>
                  )}
                </div>
              </div>
              
              <div className="talleres-tut-modal-info">
                <div className="talleres-tut-modal-header">
                  <h2 className="talleres-tut-modal-title">{selectedTaller.nombre}</h2>
                  <span className="talleres-tut-modal-nivel">{selectedTaller.nivel}</span>
                </div>
                
                <div className="talleres-tut-modal-details">
                  <div className="talleres-tut-detail-item">
                    <span className="talleres-tut-detail-icon">📅</span>
                    <div>
                      <strong>Fecha:</strong>
                      <p>{selectedTaller.fecha}</p>
                    </div>
                  </div>
                  <div className="talleres-tut-detail-item">
                    <span className="talleres-tut-detail-icon">⏰</span>
                    <div>
                      <strong>Horario:</strong>
                      <p>{selectedTaller.horario}</p>
                    </div>
                  </div>
                  <div className="talleres-tut-detail-item">
                    <span className="talleres-tut-detail-icon">⏱️</span>
                    <div>
                      <strong>Duración:</strong>
                      <p>{selectedTaller.duracion}</p>
                    </div>
                  </div>
                  <div className="talleres-tut-detail-item">
                    <span className="talleres-tut-detail-icon">👥</span>
                    <div>
                      <strong>Cupos:</strong>
                      <p>{selectedTaller.cuposDisponibles}</p>
                    </div>
                  </div>
                </div>
                
                <p className="talleres-tut-modal-description">
                  {selectedTaller.descripcion}
                </p>
                <p className="talleres-tut-modal-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt 
                  ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco 
                  laboris. Duis aute irure dolor in reprehenderit.
                </p>
                
                <div className="talleres-tut-modal-features">
                  <h4>Incluye:</h4>
                  <ul>
                    <li>✓ Material didáctico completo</li>
                    <li>✓ Certificado de participación</li>
                    <li>✓ Acceso a grabaciones (virtual/híbrido)</li>
                    <li>✓ Kit de componentes (presencial/híbrido)</li>
                    <li>✓ Soporte post-taller</li>
                  </ul>
                </div>
                
                <div className="talleres-tut-modal-footer">
                  <div className="talleres-tut-modal-precio-section">
                    <span className="talleres-tut-modal-precio-label">Precio:</span>
                    <span className="talleres-tut-modal-precio">{selectedTaller.precio}</span>
                  </div>
                  <button className="talleres-tut-modal-btn">
                    Inscribirse Ahora
                    <span className="talleres-tut-btn-arrow">→</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="talleres-tut-cta-section">
        <div className="talleres-tut-cta-container">
          <div className="talleres-tut-cta-box">
            <h2 className="talleres-tut-cta-title">
              ¿Quieres un taller personalizado para tu grupo?
            </h2>
            <p className="talleres-tut-cta-description">
              Organizamos talleres privados para empresas, universidades y grupos. Contáctanos para más información
            </p>
            <button className="talleres-tut-cta-button">
              Solicitar Taller Privado
            </button>
          </div>
        </div>
      </section>

      <FooterServices />
    </div>
  );
};

export default TalleresTut;